import { Outlet, useLocation, useNavigate } from 'react-router-dom'
import { FileText, ListTree, GraduationCap, BookOpen } from 'lucide-react'

const TABS = [
  { path: '/contents', label: '콘텐츠 관리', icon: FileText, exact: true },
  { path: '/contents/curriculum-builder', label: '커리큘럼 빌더', icon: ListTree },
  { path: '/contents/queture-contents', label: '깨처 콘텐츠', icon: GraduationCap },
  { path: '/contents/books', label: '인쇄용 책 관리', icon: BookOpen },
]

export function ContentTabLayout() {
  const location = useLocation()
  const navigate = useNavigate()

  const isActive = (tab: typeof TABS[number]) => {
    if (tab.exact) {
      return location.pathname === tab.path
    }
    return location.pathname.startsWith(tab.path)
  }

  return (
    <div className="flex flex-col h-full">
      <div className="bg-white border-b border-slate-200 px-6 shrink-0">
        <nav className="flex gap-1 -mb-px">
          {TABS.map((tab) => {
            const active = isActive(tab)
            const Icon = tab.icon
            return (
              <button
                key={tab.path}
                onClick={() => navigate(tab.path)}
                className={`flex items-center gap-2 px-4 py-3 text-sm font-medium border-b-2 transition-colors ${
                  active
                    ? 'border-blue-600 text-blue-600'
                    : 'border-transparent text-slate-500 hover:text-slate-700 hover:border-slate-300'
                }`}
              >
                <Icon className="w-4 h-4" />
                {tab.label}
              </button>
            )
          })}
        </nav>
      </div>
      <div className="flex-1 overflow-auto">
        <Outlet />
      </div>
    </div>
  )
}
